import type { Configuration } from '@repo/api-gw-sdk';
import { OrganizationsApi } from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/organization';

export const organizations = (
  httpClient: HttpClient,
  config: Configuration
) => {
  const organizationsApi = new OrganizationsApi(config);

  return {
    accounts: {
      useList: () =>
        httpClient.execute(
          organizationsApi.listOrganizationAccounts.bind(organizationsApi),
          baseUrl,
          '/accounts/list'
        ),
    },
  };
};
